import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../../context/LanguageContext/LanguageContext';
import { usePageView } from '../../hooks/usePageView';
import './Services.css';

function Services() {
  usePageView('services');
  const { t } = useLanguage();
  const s = t.services;

  return (
    <div className="services-page">
      <Helmet>
        <title>服务范围 - 首嘉/深圳瀚阳</title>
        <meta
          name="description"
          content="首嘉/深圳瀚阳提供国内货运、国际货运、仓储管理、供应链解决方案等全方位物流服务。"
        />
        <meta property="og:title" content="服务范围 - 首嘉/深圳瀚阳" />
        <meta property="og:description" content="首嘉/深圳瀚阳提供国内货运、国际货运、仓储管理、供应链解决方案等全方位物流服务。" />
        <meta property="og:url" content="https://www.sz-showjoy.com/services" />
        <meta name="keywords" content="物流服务,国内货运,国际货运,仓储管理,供应链,深圳货运,中东物流,南亚物流" />
        <link rel="canonical" href="https://www.sz-showjoy.com/services" />
      </Helmet>
      <div className="page-header">
        <div className="container">
          <h1>{s.pageTitle}</h1>
          <p>{s.pageSubtitle}</p>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="services-list">
            <div className="service-detail">
              <div className="service-icon-large">✈️</div>
              <div className="service-info">
                <h2>{s.intlTitle}</h2>
                <p className="service-description">{s.intlDesc}</p>
                <ul className="service-features">
                  {s.intlFeatures.map((f, i) => (
                    <li key={i}>✓ {f}</li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="service-detail">
              <div className="service-icon-large">📦</div>
              <div className="service-info">
                <h2>{s.warehouseTitle}</h2>
                <p className="service-description">{s.warehouseDesc}</p>
                <ul className="service-features">
                  {s.warehouseFeatures.map((f, i) => (
                    <li key={i}>✓ {f}</li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="service-detail reverse">
              <div className="service-icon-large">📊</div>
              <div className="service-info">
                <h2>{s.supplyChainTitle}</h2>
                <p className="service-description">{s.supplyChainDesc}</p>
                <ul className="service-features">
                  {s.supplyChainFeatures.map((f, i) => (
                    <li key={i}>✓ {f}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section industries">
        <div className="container">
          <h2 className="section-title">{s.industriesTitle}</h2>
          <p className="section-subtitle">{s.industriesSubtitle}</p>
          <div className="industries-grid">
            <div className="industry-card">
              <div className="industry-icon">🚢</div>
              <h3>{s.manufacturing}</h3>
            </div>
            <div className="industry-card">
              <div className="industry-icon">⛵</div>
              <h3>{s.ecommerce}</h3>
            </div>
            <div className="industry-card">
              <div className="industry-icon">📋</div>
              <h3>{s.medical}</h3>
            </div>
            <div className="industry-card">
              <div className="industry-icon">🚛</div>
              <h3>{s.food}</h3>
            </div>
            <div className="industry-card">
              <div className="industry-icon">🔗</div>
              <h3>{s.electronics}</h3>
            </div>
            <div className="industry-card">
              <div className="industry-icon">📦</div>
              <h3>{s.clothing}</h3>
            </div>
          </div>
        </div>
      </section>

      <section className="section all-services">
        <div className="container">
          <h2 className="section-title">{s.allServicesTitle}</h2>
          <p className="section-subtitle">{s.allServicesSubtitle}</p>
          <ul className="all-services-list">
            {s.allServices.map((item, i) => (
              <li key={i} className="all-services-item">
                <span className="all-services-num">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
}

export default Services;
